import React from 'react';
import { compose, hoistStatics, defaultProps } from 'recompose';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import Licenses from './Licenses';
import columnTypes from '../../components/cms/grid/columnTypes';
import ModelService from '../../services/license.service';
import {Badge} from "reactstrap";
import gc from "../../components/cms/gridComponents";

const getColumns = t => [
  {
    name: 'id',
    title: t('Id'),
    value: ({ item }) => (<Link to={ModelService.getUpdateUrl(item.id)}>{item.id}</Link>),
  },
  {
    name: 'name',
    title: t('Name'),
  },
  {
    name: 'price_monthly',
    title: t('Monthly price'),
    filter: false,
  },
  {
    name: 'price_yearly',
    title: t('Yearly price'),
    filter: false,
  },
  {
    name: 'price_single',
    title: t('Price single'),
    filter: false,
  },
  {
    name: 'token_value',
    title: t('Token value'),
    filter: false,
  },
  {
    name: 'type',
    title: t('Type'),
    value: ({ item: { type } }) => (
      <Badge color={ModelService.getColorByType(type)}>
        {ModelService.getTypeTitle(type, t)}
      </Badge>
    ),
    filter: gc.selectFilter(ModelService.getTypesOptions(t)),
  },
  {
    name: 'status',
    title: t('Status'),
    value: ({ item: { status } }) => (
      <Badge color={ModelService.getColorByStatus(status)}>
        {ModelService.getStatusTitle(status, t)}
      </Badge>
    ),
    filter: gc.selectFilter(ModelService.getStatusesOptions(t)),
  },
  {
    type: columnTypes.BUTTONS,
  },
];

const enhance = compose(
  translate('core'),
  defaultProps({
    getColumns,
  }),
);

export default hoistStatics(enhance)(Licenses);



// WEBPACK FOOTER //
// ./src/views/licenses/index.js